







import Vue from 'vue';
import { Account, AccountsTableElement } from '../types';
import AccountType from './AccountType';
import NewAccountButton from './NewAccountButton.vue';
import AccountsTable from './AccountsTable.vue';

export default Vue.extend({
  props: {
    parentId: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      default: AccountType.CLIENT,
    },
  },
  methods: {
    add(account: Account): void {
      (this.$refs.accountsTable as AccountsTableElement).add(account);
    },
  },
  components: {
    NewAccountButton,
    AccountsTable,
  },
});
